module.exports = __webpack_public_path__ + "img/details.cf7a9033.svg";